import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { UploadEvent, FileSystemFileEntry } from "ngx-file-drop";

/**
 * Shared file-drop/upload helpers used by both FrontDeskComponent and
 * TechnicianComponent. These methods were byte-identical between the two
 * components, so they are centralised here using the context-delegation
 * pattern (the calling component is passed in as `ctx`).
 */
@Injectable({
  providedIn: "root",
})
export class EmployeeUploadSharedService {
  dropped(ctx: any, i, event: UploadEvent) {
    ctx.files = [];
    for (let index = 0; index < event.files.length; index++) {
      if (event.files[index].fileEntry.isFile) {
        const fileEntry = event.files[index].fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          ctx.files.push(file);
          if (index + 1 == event.files.length) {
            ctx.i = 0;
            ctx.documentUpload(i, ctx.files);
          }
        });
      }
    }
  }

  awsUploadFile(ctx: any, file, params, index, i) {
    AWS.config.region = environment.awsRegion;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsIdentityPoolId,
    });
    if (file) {
      const Obj = ctx;
      const bucket = new S3({ params: { Bucket: params.Bucket } });
      bucket
        .upload(params)
        .on("httpUploadProgress", function (evt) {
          this.uploadPercentage = (evt.loaded * 100) / +evt.total;
          Obj.progressBarValue(this.uploadPercentage, index, i);
        })
        .send(function (err, response) {});
    }
  }
}
